import { FC } from 'react'
import { RegisterOptions, useController, useFormContext } from 'react-hook-form'
import { AutocompleteOption, ObjectDataRecord } from 'src/types'
import { SxProps } from '@mui/material/styles'

import { EnumAutocomplete, EnumAutocompleteProps } from '@components/ui/EnumAutocomplete'

type EnumAutocompleteControllerProps<T> = Omit<EnumAutocompleteProps<T>, 'onChange'>

export const EnumAutocompleteController: FC<
  EnumAutocompleteControllerProps<AutocompleteOption> & {
    handleKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>, value: string) => void
    onChange: (details: AutocompleteOption) => void
    autoFocus?: boolean
    rules?: RegisterOptions
    inputSx?: SxProps
    defaultValues?: ObjectDataRecord
  }
> = ({ handleKeyDown, onChange: handleOnChange, defaultValues = {}, ...props }) => {
  const { control } = useFormContext()
  const {
    field: { onChange, value: formValue },
    fieldState: { invalid },
  } = useController({
    name: props.name,
    control,
    rules: props.rules,
  })

  const handleChange = (details: AutocompleteOption) => {
    onChange(details?.id ?? defaultValues[props.name])
    handleOnChange?.(details)
  }

  return (
    <EnumAutocomplete
      autoFocus={props?.autoFocus}
      handleKeyDown={handleKeyDown}
      inputSx={props?.inputSx}
      invalid={invalid}
      value={props.value || formValue}
      onChange={handleChange}
      {...props}
    />
  )
}
